import React from 'react';
import { Save, Check } from 'lucide-react';
import { motion } from 'framer-motion';

interface AutoSaveProps {
  lastSaved: Date;
}

export function AutoSave({ lastSaved }: AutoSaveProps) {
  const formatTime = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    }).format(date);
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-4 right-4 bg-green-100 text-green-700 px-4 py-2 rounded-lg 
        flex items-center gap-2 shadow-lg"
    >
      <Check className="w-4 h-4" />
      <span className="text-sm">Last saved at {formatTime(lastSaved)}</span>
    </motion.div>
  );
}